/** Тексты пространства «registry». Ключи именуются по смыслу, а не по месту. */
export const registry = {
  title: 'Реестр',

  search: {
    placeholder: 'Имя, прозвище, раса',
    clear: 'Очистить поиск',
  },

  action: {
    copyForm: 'Скопировать анкету',
    playerProfile: 'Профиль игрока',
    openDossier: 'Открыть досье: {{name}}',
  },

  loading: {
    list: 'Открываем досье',
    card: 'Открываем карточку',
    items: 'Открываем склад',
    pets: 'Открываем питомцев',
    abilities: 'Открываем способности',
  },

  empty: {
    /** Своя заглушка на каждую вкладку: пусто здесь значит разное. */
    tab: {
      personnel: 'Сотрудников пока нет',
      alumni: 'Выпускников пока нет',
      resident: 'Жителей пока нет',
      professor: 'Преподавателей пока нет',
    },
    hint: 'В реестр попадают только принятые анкеты — здесь будет пусто, пока модератор не примет первую.',
    notFound: 'Никого не нашли',
    notFoundHint: 'Попробуйте другое написание имени или поищите по прозвищу.',
    form: 'Анкета почти пустая',
    formHint: 'Принятая версия анкеты не содержит заполненных полей.',
    items: 'Пока пусто: здесь появятся предметы, прошедшие проверку.',
    pets: 'У этого персонажа пока никто не живёт.',
    abilities: 'Здесь появятся стартовые способности из анкеты и то, что персонаж получил в игре.',
  },

  error: {
    noCharacter: 'Такого персонажа не существует',
    cardFailed: 'Карточка не открылась',
  },

  /** Имя группы на чипе фильтра, пока выбрано «все». */
  filter: {
    dorm: 'Общежитие',
  },

  /* Во множественном: вкладка — это группа. Про одного — `api.characterKind`. */
  tab: {
    personnel: 'Сотрудники',
    alumni: 'Выпускники',
    resident: 'Жители',
    professor: 'Преподаватели',
  },

  card: {
    /** Подпись в шапке, пока имя ещё не приехало. */
    title: 'Персонаж',
    copied: 'Анкета скопирована',
    studyClass: 'Класс {{value}}',
    /** Подпись над именем в шапке досье: кем человек числится и номер персонажа. */
    caption: '{{kind}} · {{doc}}',
  },

  /**
   * Подписи ЧИТАТЕЛЯ, а не анкеты: в карточке вопроса никто не задаёт, поэтому
   * «Характер» вместо «Характер, ценности и моральные отклонения».
   */
  field: {
    gender: 'Пол',
    age: 'Возраст',
    molesCount: 'Родинок на теле',
    nicknames: 'Прозвища и сокращения',
    nameEn: 'ФИО по-английски',
    familyText: 'Семья',
    appearanceText: 'Внешность',
    personalityText: 'Характер',
    biographyText: 'Биография',
  },

  /** Плитки перехода в разделы досье: строчными, как в холсте. */
  tile: {
    items: 'склад',
    pets: 'питомцы',
    abilities: 'способности',
  },

  pet: {
    passport: 'паспорт',
  },

  ability: {
    untitled: 'Без названия',
    expired: 'срок вышел',
    activeUntil: 'Действует до {{date}}',
    expiredAt: 'Действовала до {{date}}',
  },
} as const;
